<button mat-button [class]="class" [disabled]="disabled || showLoading" [type]="submit ? 'submit' : 'button'">
  <span [ngClass]="{ hidden: showLoading }">
    <ng-content></ng-content>
  </span>
  <span [hidden]="!showLoading" class="loading-container">
    <mat-icon>
      <mat-progress-spinner [diameter]="diameter" mode="indeterminate"></mat-progress-spinner>
    </mat-icon>
    <span class="loading-text">{{ loadingText }}</span>
  </span>
</button>
